<template>
  <v-card class="white rounded-lg">
    <v-card-title class="secondary--text">
       کد های تخفیف استفاده شده
    </v-card-title>

    <v-card-text>
      <div>
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters" ref="datatable">
          <template v-slot:item.created_at="{ item }">
            {{ format_date(item.created_at) }}
          </template>
        </m-datatable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: "DiscountCodeInFactorList",
  props: {},
  data() {
    return {
      filters: {},
      url: "sobhanAdmin/usedDiscountCodes",
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "کد",
          value: "discount_code.code",
        },
        {
          text: "درصد تخفیف",
          value: "discount_code.discount_percentage",
          type: "numeric",
        },
        {
          text: "استفاده شده توسط",
          value: "user.username",
        },
        {
          text: "در شرکت",
          value: "company_name",
        },
        {
          text: "تاریخ استفاده",
          value: "created_at",
          type: 'date'
        },
        {
          text: "شناسه یکتا تراکنش",
          value: "id",
        },
      ];

      return headers;
    },
  },
  methods: {
    format_date(value) {
      return moment(value).format("YYYY/MM/DD")
    },

  },
};
</script>

<style scoped lang="scss"></style>
